interface SwitchProps {
  id?: string
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
  /** Visually hidden label for screen readers when no visible label is wired via htmlFor. */
  ariaLabel?: string
}

/**
 * Compact on/off toggle — plain grey track, white thumb.
 */
const Switch: React.FC<SwitchProps> = ({
  id,
  checked,
  disabled = false,
  onChange,
  ariaLabel,
}) => (
  <button
    id={id}
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink/20 focus-visible:ring-offset-2 focus-visible:ring-offset-paper disabled:opacity-40 disabled:cursor-not-allowed ${
      checked ? 'bg-ink-500' : 'bg-rule-strong'
    }`}
  >
    <span
      aria-hidden
      className={`pointer-events-none inline-block h-4 w-4 rounded-full bg-paper shadow transition-transform duration-150 ease-out ${
        checked ? 'translate-x-[18px]' : 'translate-x-0.5'
      }`}
    />
  </button>
)

export default Switch
